import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import endpoints from "../../config/endpoints";
import { Sidebar } from "../../layouts/Sidebar";
import { setLoading } from "../../services/reducers/homeSlice";
import restApi from "../../services/restApi";
import tools from "../../utils/tools";
import Switch from "react-ios-switch";

const MenuManage = () => {
  const { id: paramId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form, setForm] = useState<any>({});
  const [image, setImage] = useState<any>({});
  const [menus, setMenus] = useState([]);

  const send = async () => {
    dispatch(setLoading(true));

    const res = await restApi(
      endpoints.menu.basic + (paramId || ""),
      true,
    ).post(
      tools.extractor(form, [
        "title",
        "description",
        "link",
        "parentId",
        "isRoot",
        "sort",
      ]),
    );

    if (res.code == 200) {
      if (image.data) {
        const formData = new FormData();
        formData.append("file", image.data);
        await restApi(endpoints.menu.medias + res.data.id, true).upload(
          formData,
        );
      }
      Swal.fire({
        title: "موفق",
        text: `منو با موفقیت ${paramId ? "ویرایش" : "ایجاد"} شد`,
        icon: "success",
        confirmButtonText: "متوجه شدم",
        didClose() {
          navigate("/menu");
        },
      });
    } else {
      Swal.fire({
        title: "ناموفق",
        text: res?.data,
        icon: "error",
        confirmButtonText: "متوجه شدم",
      });
    }

    dispatch(setLoading(false));
  };

  const fetchItem = async () => {
    dispatch(setLoading(true));

    if (paramId) {
      const res = await restApi(endpoints.menu.single + paramId, true).get();
      if (res.code == 200) {
        setForm({
          title: res.data?.title,
          description: res.data?.description,
          link: res.data?.link,
          parentId: res.data?.parentId,
          isRoot: res.data?.isRoot,
          sort: res.data?.sort,
        });
        setImage({
          data: undefined,
          preview: res.data.media?.url,
        });
      }
    }

    const menusRes = await restApi(endpoints.menu.index, true).get();
    if (menusRes.code == 200) {
      setMenus(menusRes.data);
    }

    dispatch(setLoading(false));
  };

  useEffect(() => {
    fetchItem();
  }, []);

  return (
    <>
      <body className="dashboardBody">
        <Sidebar />
        <main className="dashBoardMain main">
          <div className="addInfoHeader">
            <span
              className="dashboardHeader keepRight clickable"
              onClick={send}
            >
              {paramId ? "ویرایش " : "ایجاد "}منو
            </span>
            <span>
              <h1 className="sideBarTitle">بازگشت به صفحه منو ها</h1>
              <h1 className="dashBoardTitle">
                {paramId ? "ویرایش" : "ایجاد"} منو
              </h1>
            </span>
            <i
              className="backAdd clickable"
              onClick={() => navigate("/menu/")}
            ></i>
          </div>
          <section className="bottomSection">
            <h1 className="dashBoardTitle">اطلاعات منو</h1>
            <form className="addInfo">
              <label className="sideBarTitle" htmlFor="infoTitle">
                عنوان
              </label>
              <input
                className="addInput"
                id="infoTitle"
                onChange={(input: any) =>
                  setForm((prev) => ({ ...prev, title: input.target.value }))
                }
                value={form.title || ""}
              />
              <label className="sideBarTitle" htmlFor="infoLink">
                لینک
              </label>
              <input
                className="addInput"
                id="infoLink"
                onChange={(input: any) =>
                  setForm((prev) => ({ ...prev, link: input.target.value }))
                }
                value={form.link || ""}
              />
              <label className="sideBarTitle" htmlFor="infoLink">
                چینش
              </label>
              <input
                className="addInput"
                id="infoLink"
                onChange={(input: any) =>
                  setForm((prev) => ({ ...prev, sort: input.target.value }))
                }
                value={form.sort || 0}
              />
              <label className="sideBarTitle" htmlFor="infoLink">
                منو تنها
              </label>
              <Switch
                checked={form.isRoot || false}
                onChange={(checked) => {
                  setForm((prev) => ({ ...prev, isRoot: checked }));
                }}
                aria-label="سفارش فوری"
              />
              <label className="sideBarTitle">والد</label>
              <Select
                options={tools.selectFormatter(
                  menus,
                  "id",
                  "title",
                  "بدون والد",
                )}
                value={tools.selectFormatter(
                  menus.filter((e) => e.id == form.parentId),
                  "id",
                  "title",
                )}
                className="width100"
                onChange={(selected) =>
                  setForm((prev) => ({
                    ...prev,
                    parentId: selected.value.toString(),
                  }))
                }
              />
              <label className="sideBarTitle" htmlFor="infoAmount">
                توضیحات
              </label>
              <textarea
                className="addInput"
                placeholder="توضیحات"
                id="infoAmount"
                onChange={(input: any) =>
                  setForm((prev) => ({
                    ...prev,
                    description: input.target.value,
                  }))
                }
                value={form.description || ""}
              />
              <input
                type="file"
                onChange={(input) =>
                  setImage({
                    data: input.target.files[0],
                    preview: URL.createObjectURL(input.target.files[0]),
                  })
                }
              />
            </form>
            <img src={image.preview} alt="تصویر" />
          </section>
        </main>
      </body>
    </>
  );
};
export default MenuManage;
